export const screens = {
    WELCOME: 'welcome',
    LOGIN: 'login',
    SIGN_UP: 'sign_up',
    ADDITIONAL_INFO: 'additional_info',
    GET_RATED: 'get_rated',
    MISSING_INFO: 'missing_info',
    POWER_PERKS: 'power_perks',
    FLEX_LEAGUE_REFERRAL: 'flex_league_referral',
};

export const titles = {
    EVENT_REGISTER: {
        id: 'event_register',
        login: {
            title: 'Login to register for event',
            subTitle: null,
        },
        join: {
            title: 'Create your UTR Sports account and profile',
            subTitle: 'View full profiles and register for events, post scores and get rated, and more.',
        },
    },
    IMPORTED_EVENT: {
        id: 'imported_event',
        login: {
            title: 'Log in to view this event',
            subTitle: null,
        },
        join: {
            title: 'Create your UTR Sports account and profile',
            subTitle: 'View full event results and player ratings, register for events and more.',
        },
    },
    PLAYER_PROFILE: {
        id: 'player_profile',
        login: {
            title: 'Log in to view full profile',
            subTitle: null,
        },
        join: {
            title: 'Create your UTR Sports account and profile',
            subTitle: 'View player ratings and results, join clubs, register for events and more.',
        },
    },
    REQUEST_TO_JOIN_CLUB: {
        id: 'request_to_join_club',
        login: {
            title: 'Log in to join this club',
            subTitle: null,
        },
        join: {
            title: 'Create your UTR Sports account and profile',
            subTitle: 'Join clubs, follow teams, register for events and more.',
        },
    },
    SEARCH_PAGE: {
        id: 'search_page',
        login: {
            title: 'Log in to view more search results',
            subTitle: null,
        },
        join: {
            title: 'Create your UTR Sports account and profile',
            subTitle: 'View more search results, post scores and get rated, register for events and more.',
        },
    },
    NCSA_REGISTER: {
        id: 'ncsa_register',
        login: {
            title: 'Sign in to register with NCSA',
            subTitle: null,
        },
        join: {
            title: 'Create your UTR Sports account and profile',
            subTitle: null,
        },
    },
    POWER_PERKS: {
        id: 'power_perks',
        login: {
            title: 'Log in to view the Power Perks',
            subTitle: null,
        },
        join: {
            title: 'Create your UTR Sports account and profile',
            subTitle: 'Access your analytics, apply your partner benefits, and power up your play!',
        },
    },
    FLEX_LEAGUE_REFERRAL: {
        id: 'flex_league_referral',
        login: {
            title: 'Log in to invite friends to a flex league',
            subTitle: null,
        },
        join: {
            title: 'Create your UTR Sports account and profile',
            subTitle: '',
        },
    },
    COLLEGE_CORNER: {
        id: 'college_corner',
        login: {
            title: 'Log in to view more college corner',
            subTitle: 'Get access to view college teams, players and much more.',
        },
        join: {
            title: 'Create your UTR Sports account and profile',
            subTitle: null,
        },
    },
};

export const userParams = {
    CLAIMED_PROFILE: 'claimedPlayer',
    BIRTHDATE: 'birthdate',
    LOCATION: 'location',
    PHONE: 'phone',
    GENDER: 'gender',
};

export const getUserParamMissing = (auth, userParamsNeeded) => {
    if (auth && auth.user && userParamsNeeded && userParamsNeeded.length > 0) {
        let missingParam;
        userParamsNeeded.forEach((userParam) => {
            if (!auth.user[userParam]) {
                missingParam = userParam;
                return false;
            }
            return null;
        });
        return missingParam;
    }
    return null;
};

export const screenToDisplay = (auth, userParamsNeeded) => {
    const user = auth && auth.user;
    const paramMissing = getUserParamMissing(auth, userParamsNeeded);
    if (!user || paramMissing) {
        if (user) {
            // TODO redirect to onboarding screen
            if (!user.onboardingCompleted) {
                if (user.onboardingStep > 1) {
                    return screens.GET_RATED;
                }
                return screens.ADDITIONAL_INFO;
            }
            if (paramMissing) {
                if (paramMissing === userParams.CLAIMED_PROFILE) {
                    return screens.GET_RATED;
                }
                if ((paramMissing === userParams.BIRTHDATE) ||
                    (paramMissing === userParams.LOCATION) ||
                    (paramMissing === userParams.PHONE) ||
                    (paramMissing === userParams.GENDER)) {
                    return screens.MISSING_INFO;
                }
                return null;
            }
            return null;
        }
        return screens.SIGN_UP;
    }
    return null;
};

export const isLoginPopUpNeeded = (auth, userParamsNeeded) => {
    if (auth?.user) {
        const paramMissing = getUserParamMissing(auth, userParamsNeeded);
        // Don't show popup/redirect to onboarding if user has completed onboarding but still missing claimedPlayer
        // Prevents infinite redirect loop for users in broken state
        if (paramMissing === userParams.CLAIMED_PROFILE && auth.user.onboardingCompleted) {
            return null;
        }
        return paramMissing;
    }
    return true;
};

export const areOnboardingScreens = (screen) => {
    const onboardingScreens = [screens.ADDITIONAL_INFO, screens.GET_RATED, screen.MISSING_INFO];
    return onboardingScreens.includes(screen);
};
